module.exports = __webpack_public_path__ + "static/media/download.479e6797.png";